/**
 * @generated SignedSource<<036e6c78613c5af00ff55f7741b4afc6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraMultipleSelectUserPickerField_Platform$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly selectedUsersConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly accountId: string;
        readonly id: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "JiraMultipleSelectUserPickerField_Platform";
};
export type JiraMultipleSelectUserPickerField_Platform$key = {
  readonly " $data"?: JiraMultipleSelectUserPickerField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraMultipleSelectUserPickerField_Platform">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraMultipleSelectUserPickerField_Platform",
  "selections": [
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        }
      ]
    },
    {
      "concreteType": "JiraUserConnection",
      "kind": "LinkedField",
      "name": "selectedUsersConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraUserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                },
                {
                  "kind": "ScalarField",
                  "name": "picture"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraMultipleSelectUserPickerField"
};

(node as any).hash = "03d643e1f86865d308a30b45583702b9";

export default node;
